<!-- 
LISTA DE REGISTROS DE LOG DO FINANCEIRO

/fin/log/      -> lista de historico de titulos do financeiro
-->

<script>
import axios from 'axios'
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import FinanceiroForm from './financeiro-form'
import { apiDownload, apiDownloadPDF, urlORDS } from '../shared/api-functions'
import { getText, formatDate, formatValue } from '../shared/utils'
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'
import { apiORDSpost } from '../shared/api-functions'
import { SysVars } from '../main';

export default {
    data () {
        return {
            fiter: '',
            metadata: this.$store.getters.getEntities.metadata,
            monthFilter: {},
            statusQuery: '',
            textQuery: '',
        }
    },
    computed: {
        logList: function () {
            return this.$store.getters.getLogList
        },
    },
    watch: {
    },
    methods: {
        handleTextSearch(value) {
            //efetua a pesquisa por texto
            this.filter = ''
            if (value) {
                this.filter = 'text=' + value
            }
            this.monthQuery = ''
            this.loadData()
        },

        handleAdvancedFilter (filter, startDate, endDate) {
            //aplicação do filtro avancado
            this.monthQuery = 'after=' + startDate + '&before=' + endDate
            this.filter = ''
            this.loadData()
        },

        loadData() {
            let param = {}
            param.query = ''
            if (this.textQuery) {
                param.query = param.query + this.textQuery
            } else if (this.monthQuery) {
                param.query = param.query + this.monthQuery
            }
            this.$store.dispatch('loadLogList', param)
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        textACAO (log) {
            if (log.tipolog === 'CREATE') {
                return 'Incluiu o recebimento ' + log.texto
            } else if (log.tipolog === 'UPDATE') {
                return 'Alterou o recebimento ' + log.texto
            } else if (log.tipolog === 'DELETE') {
                return 'Excluiu o recebimento ' + log.texto
            } else if (log.tipolog === 'PAY') {
                return 'Baixou o recebimento ' + log.texto
            } else if (log.tipolog === 'UNPAY') {
                return 'Cancelou a baixa do recebimento ' + log.texto
            }
        },

        data (value) {
            return formatDate(value)
        },        

    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    components: {
        BarList, BarGrid, FilterList
    },

    created () {
        this.loadData()
    }

}

</script>

<template>

    <div>
        <div> 
            <bar-list
                :refresh-button="true" 
                :new-button="false" 
                single-entity="Histórico" 
                plural-entity="Histórico"
                :filtro-mes="true"
                @refresh="loadData"
                @search="handleTextSearch"
                @filter="handleAdvancedFilter">
            </bar-list>
            <br>
            <div class="default-container">
                <alert v-if="logList.length == 0" type="warning" text="Nenhum registro encontrado"></alert>
                <div class="mainbox" v-for="log in logList" :key="log.codfin">
                    <div class="mark-gray"></div>
                    <div class="box">
                        <div class="row">
                            <div class="col-md-2 col-3">
                                <label class="lbl-list">Data</label>
                                <span class="data-list">{{ data(log.data) }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <label class="lbl-list">Documento</label>
                                <span v-if="log.parcela" class="data-list">{{ log.doc }} / {{ log.parcela }}</span>
                                <span v-if="!log.parcela" class="data-list">{{ log.doc }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <label class="lbl-list">Valor</label>
                                <span class="data-list">{{ log.vlr | format }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <span class="data-list">{{ log.usuario }}</span>
                            </div>
                            <div class="col-md-3 col-6">
                                <span class="data-list">{{ textACAO(log) }}</span>
                            </div>
                            <div class="col-md-3 col-6">
                                <span class="data-list">{{ log.part_nome }}</span>
                            </div>
                            <div class="col-md-1 col-1">
                                <v-button title="Visualizar o documento" icon="fa-search" @click="handleVisualiza(log.id)"></v-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>


<style>
</style>






// WEBPACK FOOTER //
// src/forms/financeirolog-list.vue